<template>
  <article
    class="relative overflow-hidden rounded-[20px] bg-[#3B50F0] p-4"
    @click="$emit('onClick')"
  >
    <div class="flex items-center gap-2">
      <div class="max-w-[calc(100%-120px)] flex-1 space-y-3">
        <span
          class="bg-static-white/10 inline-flex items-center rounded-[20px] px-2 py-0.75 backdrop-blur-[50px]"
        >
          <span class="text-static-white text-xs font-medium">
            {{ promo.daysLeftText.value }}
          </span>
        </span>
        <p class="text-static-white leading-5.5 font-semibold text-balance">
          {{
            t('avia-tour-promo.title-suffix', {
              sum: promo.discountAmountText,
            })
          }}
        </p>
      </div>
      <img
        width="141"
        height="113"
        src="../assets/gift.webp"
        class="absolute top-0 right-0 h-full w-35.25 shrink-0 object-cover"
        alt=""
        loading="lazy"
        decoding="async"
      />
    </div>

    <FreeCloseButton
      v-if="withCloseButton"
      class="close-button absolute top-2 right-2"
      @click.stop="$emit('onClose')"
    />
  </article>
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { FreeCloseButton } from '../../../shared/ui';
  import { useAviaTourPromo } from '../model/use-avia-tour-promo.ts';
  import messages from '../locales.json';

  defineProps<{
    withCloseButton?: boolean;
  }>();

  const emit = defineEmits<{
    onShown: [];
    onClick: [];
    onClose: [];
  }>();

  const { t } = useI18n({ messages });
  const promo = useAviaTourPromo();

  onMounted(() => {
    emit('onShown');
  });
</script>

<style scoped>
  .close-button {
    --header-close-button-background-color: rgb(var(--static-white));
    --header-close-button-cross-color: rgb(var(--static-black));
  }
</style>
